(() => {
  class ProductInfoDrawer {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId || Math.random().toString(36).slice(2);

      this.overlay = root.querySelector('.product-info-drawer-tabs__overlay');
      this.drawer = root.querySelector('.product-info-drawer-tabs__drawer');
      this.title = root.querySelector('.product-info-drawer-tabs__title');
      this.closeButton = root.querySelector('.product-info-drawer-tabs__close');
      this.buttons = Array.from(root.querySelectorAll('.product-info-drawer-tabs__trigger'));
      this.panels = Array.from(root.querySelectorAll('.product-info-drawer-tabs__panel'));

      this.lastTrigger = null;
      this.closeTimer = null;

      this.onKeyDown = this.onKeyDown.bind(this);

      this.portalize();
      this.bindEvents();
    }

    portalize() {
      if (this.overlay && this.overlay.parentNode !== document.body) {
        this.overlay.setAttribute('data-drawer-portal', this.sectionId);
        document.body.appendChild(this.overlay);
      }

      if (this.drawer && this.drawer.parentNode !== document.body) {
        this.drawer.setAttribute('data-drawer-portal', this.sectionId);
        document.body.appendChild(this.drawer);
      }
    }

    bindEvents() {
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const isSameButtonOpen =
            this.drawer &&
            !this.drawer.hidden &&
            button.classList.contains('is-active');

          if (isSameButtonOpen) {
            this.close();
            return;
          }

          this.open(button.dataset.panelTarget, button);
        });
      });

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close());
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }
    }

    open(panelId, trigger) {
      if (!this.drawer) return;

      const targetPanel = this.panels.find((panel) => panel.dataset.panel === panelId);
      if (!targetPanel) return;

      clearTimeout(this.closeTimer);

      this.lastTrigger = trigger;

      this.buttons.forEach((button) => {
        const isActive = button === trigger;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel !== targetPanel;
      });

      if (this.title) {
        this.title.textContent = trigger.textContent.trim();
      }

      if (this.overlay) {
        this.overlay.hidden = false;
      }

      this.drawer.hidden = false;

      requestAnimationFrame(() => {
        this.drawer.classList.add('is-open');
      });

      this.root.classList.add('is-open');
      document.documentElement.classList.add('product-info-drawer-open');
      document.body.classList.add('product-info-drawer-open');
      document.addEventListener('keydown', this.onKeyDown);

      if (this.closeButton) {
        this.closeButton.focus();
      }
    }

    close() {
      if (!this.drawer) return;

      clearTimeout(this.closeTimer);

      this.root.classList.remove('is-open');
      this.drawer.classList.remove('is-open');

      this.buttons.forEach((button) => {
        button.classList.remove('is-active');
        button.setAttribute('aria-expanded', 'false');
      });

      document.documentElement.classList.remove('product-info-drawer-open');
      document.body.classList.remove('product-info-drawer-open');
      document.removeEventListener('keydown', this.onKeyDown);

      this.closeTimer = window.setTimeout(() => {
        this.drawer.hidden = true;

        if (this.overlay) {
          this.overlay.hidden = true;
        }

        this.panels.forEach((panel) => {
          panel.hidden = true;
        });
      }, 240);

      if (this.lastTrigger) {
        this.lastTrigger.focus();
      }
    }

    onKeyDown(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    }
  }

  const initProductInfoDrawers = () => {
    document.querySelectorAll('.js-product-info-drawer').forEach((root) => {
      if (root.dataset.drawerInitialized === 'true') return;
      root.dataset.drawerInitialized = 'true';
      new ProductInfoDrawer(root);
    });
  };

  document.addEventListener('DOMContentLoaded', initProductInfoDrawers);
  document.addEventListener('shopify:section:load', initProductInfoDrawers);
})();